import { Component, inject, Input } from '@angular/core';
import { ErrorService } from '../services/error.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NZ_MODAL_DATA, NzModalModule, NzModalService } from 'ng-zorro-antd/modal';
import { TranslocoDirective } from '@jsverse/transloco';
import { ButtonComponent } from '@ui';

/**
 * Component to display error messages associated with a specific error key.
 * Automatically subscribes to updates from the `ErrorService` and updates the displayed message dynamically.
 */
@Component({
  selector: 'error-display',
  imports: [NzModalModule, TranslocoDirective, ButtonComponent],
  template: `
    <!-- Conditionally displays the error message if available -->
    <!-- @if(errorMessage) {
      <div class="text-white bg-red-500 p-4 mb-4 rounded-lg">
        {{ errorMessage }}
      </div>
    } -->
    <div class="error-modal" *transloco="let t">
      <div class="error-icon">
        <span nz-icon nzType="close-circle" nzTheme="fill" class="error-icon"></span>
      </div>
      <h3>{{ t(nzModalData.errorTitle) }}</h3>
      <p class="error-message">{{ t(nzModalData.errorMessage) }}</p>
      <div *nzModalFooter>
          <ui-button
            class="flex justify-end"
            buttonType="primary"
            buttonSize="default"
            buttonShape="round"
            [loading]="false"
            [disabled]="false"
            (buttonClick)="nzModalData.modalService.closeAll()"
          >
            {{ t('ADMIN.ERROR.MODAL_BTN') }}
          </ui-button>
      </div>
    </div>
  `,
  styles: [], // No custom styles, using TailwindCSS classes instead.
})
export class ErrorDisplayComponent {
  @Input() errorMessage!: string;
  @Input() modalService!: NzModalService;
  @Input() errorTitle: string = 'Error';
  /**
   * Injects the `ErrorService` to retrieve and manage error messages.
   */
  protected readonly errorService = inject(ErrorService);
  readonly nzModalData: any = inject(NZ_MODAL_DATA);

  /**
   * The unique key identifying the error context to display.
   * This input must be provided by the parent component.
   */
  @Input() errorKey!: string;

  /**
   * Holds the error message to be displayed. Defaults to `null` if no error exists.
   */
  // errorMessage: string | null = null;
  isVisibleModalError = false;

  /**
   * Subscribes to the error stream for the given `errorKey` on initialization.
   * Automatically unsubscribes when the component is destroyed.
   */
  ngOnInit(): void {
    // this.errorService
    //   .getError$(this.errorKey)
    //   .pipe(takeUntilDestroyed())
    //   .subscribe((message) => {
    //     console.log("error", message)
    //     // this.errorMessage = message; // Updates the error message dynamically.
    //     this.showModalMiddle()
    //   });
  }

  showModalMiddle(): void {
    this.isVisibleModalError = true;
  }

  handleOkModalError(): void {
    this.isVisibleModalError = false;
  }
}
